import React, { useEffect, useState } from 'react'
import { useAppSelector } from 'src/redux/hooks'
import { STEPS } from '../QuestionsPatienteView'
import { Box, Button, Checkbox, FormControl, FormLabel, Input, Radio, Stack } from '@chakra-ui/react'

interface Props {
  step: number,
  setStep: React.Dispatch<React.SetStateAction<STEPS>>,
  isLoadingTranslate:boolean
}

const QuestionsView: React.FC<Props> = ({ step, setStep,isLoadingTranslate }) => {
  const { questions } = useAppSelector((state) => state.question)
  const [filtredQuestions, setFiltredQuestions] = useState<any[]>([])

  const handleClickNext = () => {
    if (step !== 2) {
      setStep((prev) => prev + 1)
    }
  }

  const handleGoBack = () => {
    if (step !== 0) {
      setStep((prev) => prev - 1)
    }
  }

  useEffect(() => {
    const filterQuestionsAccordingToCategory = questions?.filter((q) => q?.question_to === "patient" && q?.category === (step === 0 ? "Généralités" : step === 1 ? "Concernant votre grossesse actuelle" : "Concernant votre santé en dehors de la grossesse"))
    setFiltredQuestions(filterQuestionsAccordingToCategory)
  }, [step,questions])
  
  return (
    <Box py={4} my={4} >
      <Box sx={{display:"flex",flexDir:"column",gap:4}}>
        {filtredQuestions?.map((question, index) => {
          return (
            <FormControl isRequired={question?.is_required === 1} key={index} >
              <FormLabel color={"black"}  >{question.question}</FormLabel>
              {question.type === 'text' || question.type === 'number' || question.type === 'date' ? (
                <Input
                  boxShadow='sm'
                  rounded='5px'
                  type={question.type === 'date' ? 'date' : question.type === 'text' ? 'text' : 'number'}
                  size='md'
                isDisabled
                  placeholder='Reponse...'
                />
              ) : question.type === 'selectbox' ? (
                <Stack spacing={5} direction='column'>
                  {question?.possibles_answers?.map((answer: { id: number, answer: string }, index2: any) => (
                    <Radio isDisabled key={index2} >
                      {answer.answer}
                    </Radio>
                  ))}
                </Stack>
              ) : (
                <Box>
                  <Stack spacing={5} direction='column'>
                    {question.possibles_answers?.map((answer: { id: number, answer: string }, index2: number) => (
                      <Checkbox isDisabled colorScheme='blue'  key={index2} >{answer.answer}</Checkbox>
                    ))}
                  </Stack>
                  {question?.question_id === 46 && <Input
                      mt={4}
                      boxShadow='sm'
                      // disabled={isSubmitting}
                      rounded='5px'
                      type="text"
                      size='md'
                      placeholder='quel est le produit,l’aliment ou le médicament responsable ?'
                    />}
                    
                </Box>
              )
              }
            </FormControl>
          )
        })}
        <Stack direction='row' mt={4} justifyContent='space-between' alignItems='center' >
          <Button type='submit' variant='ghost' colorScheme='blue'>Enregistrer les réponses</Button>
          <Stack direction={{ base: 'column', md: 'row' }}>
            {step !== 0 ? (
              <Button type='button' px={10} variant='outline' borderColor='black' _hover={{ bg: 'blue.500', borderColor: 'blue.500', color: 'white' }} onClick={handleGoBack}>Précédent</Button>
            ) : null}
            <Button type='button' px={10} colorScheme='blue' onClick={handleClickNext} >{step === 2 ? "Envoyer" : `Continuer (${step + 1}/${3})`}</Button>
          </Stack>
        </Stack>
      </Box>
    </Box>
  )
}

export default QuestionsView